/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_Registration_TitleInputs */

const en_admin_embed_registration_title = /** @type {(inputs: Admin_Embed_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week registration`)
};

const de_admin_embed_registration_title = /** @type {(inputs: Admin_Embed_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung zur Matching Week`)
};

/**
* | output |
* | --- |
* | "Matching Week registration" |
*
* @param {Admin_Embed_Registration_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_registration_title = /** @type {((inputs?: Admin_Embed_Registration_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_Registration_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_registration_title(inputs)
	return en_admin_embed_registration_title(inputs)
});